export const defaultOnNavigate = {
	callback: (url: string): void => {
		window.location.href = url;
	},
	options: {
		alwaysUseOnLinkClick: false,
	},
};
